module.exports = __webpack_public_path__ + "img/blog-list.6d180b1f.png";